<lib-form-field-container
    #anchor
    [kind]="FormContainerKind.Date"
    [isOptional]="isOptional"
    [hideErrors]="popupOpen">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>

    <ng-container prefixIcon>
        <lib-icon-button
            [kind]="ButtonKind.FormField"
            [size]="ButtonSize.Large"
            [disabled]="isDisabled"
            [icon]="prefixIcon"
            (clicked)="OpenDatePicker()"></lib-icon-button>
    </ng-container>
    <ng-container readOnly>
        <div
            #providedReadOnly
            class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content">
            @if (formControl.value) {
                {{ formControl.value[0].Render() + ' - ' + formControl.value[1].Render() }}
            } @else {
                <ng-container
                    i18n="@@CommonNotSpecifiedLabel">
                    Not specified
                </ng-container>
            }
        </div>
    </ng-container>

    @if (!isReadOnly) {
        <lib-menu-button
            menu
            [disabled]="isDisabled"
            [kind]="ButtonKind.Link">
            <ng-container
                label
                i18n="@@CommonQuickSelectLabel">
                Quick Select
            </ng-container>
            @if (showFutureDates) {
                <lib-menu-item
                    i18n-label="@@CommonFormFieldNextMonthLabel"
                    label="Next Month"
                    [stopPropagation]="true"
                    (clicked)="Preset('nextmonth')">
                </lib-menu-item>
            }
            <mat-divider class="mx-2 mt-1 pb-1"></mat-divider>
            <lib-menu-item
                i18n-label="@@CommonFormFieldThisMonthLabel"
                label="This Month"
                [stopPropagation]="true"
                (clicked)="Preset('thismonth')"></lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonFormFieldThisYearLabel"
                label="This Year"
                [stopPropagation]="true"
                (clicked)="Preset('thisyear')"></lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonFormFieldYearToDateLabel"
                label="Year to Date"
                [stopPropagation]="true"
                (clicked)="Preset('yeartodate')">
            </lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonFormFieldTodayLabel"
                label="Today"
                [stopPropagation]="true"
                (clicked)="Preset('today')">
            </lib-menu-item>
            <mat-divider class="mx-2 mt-1 pb-1"></mat-divider>
            <lib-menu-item
                i18n-label="@@CommonFormFieldLast7DaysLabel"
                label="Last 7 Days"
                [stopPropagation]="true"
                (clicked)="Preset('last7days')"></lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonFormFieldLast30DaysLabel"
                label="Last 30 Days"
                [stopPropagation]="true"
                (clicked)="Preset('last30days')"></lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonFormFieldLastMonthLabel"
                label="Last Month"
                [stopPropagation]="true"
                (clicked)="Preset('lastmonth')"></lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonFormFieldLastYearLabel"
                label="Last Year"
                [stopPropagation]="true"
                (clicked)="Preset('lastyear')">
            </lib-menu-item>
            <lib-menu-item
                i18n-label="@@CommonFormFieldClearSelectionLabel"
                label="Clear Selection"
                [stopPropagation]="true"
                [menuDivider]="MenuDivider.Above"
                (clicked)="ClearSelection()">
            </lib-menu-item>
        </lib-menu-button>
    }
    <input
        #input
        [hidden]="isLoading || isReadOnly"
        mbsc-datepicker
        select="range"
        [formControl]="viewControl"
        autocomplete="off"
        autocorrect="off"
        spellcheck="false"
        [anchor]="anchor?.containerBox?.nativeElement"
        [min]="minDateJS"
        [max]="maxDateJS"
        [touchUi]="isMobile"
        [attr.data-sb-qa]="qaTag"
        [showRangeLabels]="showRangeLabels"
        [attr.placeholder]="placeholderText"
        [dayNamesShort]="localeInfo.AbbreviatedDayNames"
        [monthNames]="localeInfo.MonthNames"
        [monthNamesShort]="localeInfo.AbbreviatedMonthNames"
        [dayNamesMin]="localeInfo.AbbreviatedDayNames"
        [firstDay]="firstDayOfWeek"
        [rtl]="localeInfo.RightToLeft"
        (onChange)="ChangeEvent($event)"
        (onOpen)="PopupOpened($event)"
        (onClose)="CloseEvent($event)"
        (onInit)="ComponentInitialized($event)"
        (change)="$event.stopPropagation()"
        [dateFormat]="dateFormat | uppercase"
        themeVariant="light"
        [focusOnClose]="false"
        (blur)="OnBlur()"
        (focus)="OnFocus()" />
</lib-form-field-container>